import jQuery from "jquery";
import Fuse from "fuse.js";
import debounce from "./debounce";

export function initSearchGroup() {
	jQuery('[data-search-group]').each(function() {
		const group = $(this);

		const input = group.find('input.search-input');
		const clearBtn = group.find('.search-input-clear');

		const container = group.find('.search-item-container');
		const resultContainer = container.clone().insertAfter(container);
		const elements = resultContainer.find('[data-search-value]');

		const options = {
			shouldSort: true,
			threshold: 0.5,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			includeScore: true,
			keys: ['searchValue']
		};

		resultContainer.empty();

		// prepare elements for Fuse component
		const items = elements.map((idx, el) => {
			el = $(el);
			return {
				element: el,
				searchValue: el.data('searchValue').toLowerCase()
			};
		});
		const fuse = new Fuse(items, options);

		// search with Fuse and only show sorted hits
		const filter = (q) => {
			const results = fuse.search(q);

			const newElements = results.map((result) => {
				return result.item.element;
			});

			container.hide();
			resultContainer.empty().append(newElements);
		};

		const showAll = () => {
			resultContainer.empty().append(elements);
		};

		input.on('input change', debounce(function() {
			if(input.val().length > 0) {
				filter(input.val());
			} else {
				showAll();
			}
		}, 200));

		clearBtn.click(() => input.val(''));
	});
}
